import { getMyAccessRoute, listMyOrganizationsRoute, listMyVenuesRoute } from "./access.js";
import { AUTH_ROUTES } from "./auth.js";
import { getHqBrandRoute, getMetaRoute, putHqBrandRoute } from "./brand.js";
import { acknowledgeCallRoute, cancelCallRoute, listCallsRoute, raiseCallRoute, resolveCallRoute, } from "./calls.js";
import { applyDiscountCodeRoute, applyManualDiscountRoute, approveSaleRefundRoute, cancelSaleRoute, createSaleRoute, quoteSaleRoute, getSaleDocumentRoute, printSaleDocumentRoute, setSaleBuyerRoute, getCounterUpiRoute, getSaleRoute, listSalesRoute, lookupRetailProductRoute, refundSaleRoute, sendSaleDocumentRoute, takeSalePaymentRoute, } from "./commerce.js";
import { createDiscountCodeRoute, listDiscountCodesRoute, updateDiscountCodeRoute } from "./discounts.js";
import { createPromotionRoute, listPromotionsRoute, updatePromotionRoute } from "./promotions.js";
import { createCouponBatchRoute, listCouponBatchesRoute, redeemCouponRoute } from "./coupons.js";
import { checkStationDiscountCodeRoute, quoteStationSaleRoute, redeemStationCouponRoute } from "./station-codes.js";
import { getStationAccountRoute, pinStationSessionPassRoute } from "./station-account.js";
import { claimGuestPassRoute, listGuestPassesRoute, redeemStationTicketRoute } from "./guest-passes.js";
import { getStationSaleOutstandingRoute, retryStationSaleUpiRoute } from "./station-sales.js";
import { cancelStationWalletTopUpRoute, cancelWalletTopUpRequestRoute, completeWalletTopUpRequestRoute, getStationWalletTopUpRoute, listWalletTopUpRequestsRoute, requestStationWalletTopUpRoute, } from "./wallet-topup-requests.js";
import { getStationLockdownTestRoute, issueStationRecoveryCodeRoute, reportStationLockdownTestRoute, reportStationMaintenanceEventRoute, runStationLockdownTestRoute, signInStationMaintenanceRoute, } from "./station-lockdown.js";
import { getStationOfflinePolicyRoute, issueOfflineStaffCodesRoute, listOfflineSessionsRoute, listOfflineStaffCodesRoute, reportStationOfflineSessionRoute, resolveOfflineSessionRoute, revokeOfflineStaffCodeRoute, } from "./offline-play.js";
import { getPlayerCreditRoute, setPlayerCreditRoute, settleReceivableRoute, takeSaleOnAccountRoute, writeOffReceivableRoute, } from "./credit.js";
import { getVenueTaxRegistrationRoute, scheduleVenueTaxRegistrationRoute, withdrawVenueTaxRegistrationRoute, } from "./tax-registration.js";
import { createTaxCategoryRoute, listTaxCategoriesRoute, updateTaxCategoryRoute } from "./tax-categories.js";
import { getVenueRateCardRoute, publishVenueRateCardRoute } from "./rate-cards.js";
import { exportOrganizationAuditRoute, exportPlatformAuditRoute, listOrganizationAuditRoute, listPlatformAuditRoute, } from "./audit.js";
import { createDeviceAuthChallengeRoute, createDeviceAuthTokenRoute } from "./device-auth.js";
import { approveDevicePairingRoute, createDevicePairingRoute, getDevicePairingRoute } from "./device-pairings.js";
import { completeFileRoute, createFileRoute, getFileRoute } from "./files.js";
import { getFloorPlanRoute, putFloorPlanRoute } from "./floor-plan.js";
import { generateOfflineCodeRoute, getFloorRoute, lockStationRoute, messageStationRoute, setStationMaintenanceRoute, skipStationSetupRoute, stationPowerRoute } from "./floor.js";
import { listFranchiseeVenuesRoute, listFranchiseesRoute } from "./franchisees.js";
import { cancelFoodOrderRoute, createMenuCategoryRoute, createMenuProductRoute, getFoodOrderRoute, getMenuProductRoute, getStationMenuRoute, getVenueMenuRoute, listFoodOrdersRoute, listMenuCategoriesRoute, listMenuProductsRoute, placeFoodOrderRoute, placeStationFoodOrderRoute, putVenueMenuOverridesRoute, setProductAvailabilityRoute, setVenueProductAvailabilityRoute, updateMenuCategoryRoute, updateMenuProductRoute, } from "./food.js";
import { advanceKitchenTicketRoute, listKitchenTicketsRoute, printKitchenTicketRoute } from "./kitchen.js";
import { BOOT_ROUTES } from "./boot.js";
import { BOOT_RELEASE_ROUTES } from "./boot-releases.js";
import { archivePrinterRoute, createPrinterRoute, epsonServerDirectPrintRoute, listPrintersRoute, listPrintJobsRoute, printSaleReceiptRoute, starCloudPrntConfirmRoute, starCloudPrntJobRoute, starCloudPrntPollRoute, testPrinterRoute, updatePrinterRoute, } from "./printers.js";
import { helloRoute } from "./hello.js";
import { INTERNAL_ROUTES } from "./internal.js";
import { addSessionTimeRoute, addTimeStationSessionRoute, quoteConsoleSessionRoute, quoteSessionChangeRoute, setSessionControllersRoute, useWalletStationSessionRoute, setStationWalletUseRoute, compSessionRoute, endSessionRoute, lockSessionRoute, endStationSessionRoute, getSessionStatusRoute, getSessionTimelineRoute, listSessionLedgerRoute, getStationFundingOptionsRoute, getStationSessionLeaseRoute, getStationSessionRoute, lockStationSessionRoute, messageSessionRoute, moveSessionRoute, reportStationSessionEndRoute, sellSessionTimeRoute, startSessionRoute, startStationSessionRoute, unlockStationSessionRoute, } from "./sessions.js";
import { acceptInvitationRoute, previewInvitationRoute, changeMemberRoleRoute, changeMemberStatusRoute, changeMemberVenuesRoute, changeMemberLimitsRoute, changeRoleLimitsRoute, createInvitationRoute, createRoleRoute, deleteRoleRoute, getMemberLimitsRoute, getMemberRoute, getRoleRoute, listInvitationsRoute, listMembersRoute, listRolesRoute, removeMemberRoute, revokeInvitationRoute, updateRoleRoute, } from "./members.js";
import { healthzRoute, readyzRoute } from "./health.js";
import { createHqOrganizationRoute, createHqOwnerInvitationRoute, decideHqOrganizationRoute, getHqOrganizationOwnerRoute, getHqOrganizationRoute, getHqOwnerInvitationLinkRoute, listHqOrganizationsRoute, registerPendingOrganizationRoute, resendHqOwnerInvitationRoute, withdrawHqOwnerInvitationRoute, } from "./hq-organizations.js";
import { clearGameArtRoute, completeGameTrailerRoute, createGameTrailerRoute, deleteGameTrailerRoute, listCatalogueGamesRoute, listGameArtCandidatesRoute, listGameTrailersRoute, mirrorCatalogueGameRoute, refreshCatalogueGameRoute, searchCatalogueRoute, setCatalogueGameLaunchRecipesRoute, setCatalogueTitleDetectionRoute, setGameArtRoute, createCatalogueAppRoute, updateCatalogueAppRoute, updateGameTrailerRoute, seedCommonCatalogueAppsRoute, createAppIconUploadRoute, completeAppIconUploadRoute, createCatalogueGameRoute, updateCatalogueGameRoute, getCatalogueGameUsageRoute, archiveCatalogueGameRoute, unarchiveCatalogueGameRoute, testCatalogueDetectionRoute, } from "./hq-catalogue.js";
import { getHqPlayerRoute, listHqPlayersRoute } from "./hq-players.js";
import { listHqProvidersRoute, testHqProviderRoute } from "./hq-providers.js";
import { archiveCustomAppRoute, browseVenueCustomAppsRoute, completeCustomAppIconUploadRoute, createCustomAppIconUploadRoute, createCustomAppRoute, listCustomAppsRoute, updateCustomAppRoute, } from "./custom-apps.js";
import { addLibraryEntryRoute, browseVenueCatalogueRoute, listLibraryEntriesRoute, removeLibraryEntryRoute, updateLibraryEntryRoute, } from "./library.js";
import { createCatalogueRequestRoute, listCatalogueRequestsRoute, resolveCatalogueRequestRoute, getLibraryInstallMatrixRoute, getStationInstalledTitlesRoute, getStationLibraryAvailabilityRoute, listDetectedTitlesRoute, installLibraryEntryRoute, installStationAppRoute, putStationInstalledRoute, rescanLibraryInstallsRoute, } from "./station-installs.js";
import { getStationWakeListRoute, getStationWakeStatusRoute, postStationWakeSendRoute, putStationWakeReadinessRoute } from "./station-wake.js";
import { getStationClientUpdateRoute, getStationFleetRoute, getStationReleaseKeysRoute, getVenueStationInstallersRoute, installStationClientUpdateNowRoute, listStationReleasesRoute, listStationRolloutsRoute, listVenueStationClientsRoute, putStationClientUpdateStatusRoute, registerStationReleaseRoute, setStationRolloutRoute, updateStationReleaseRoute, } from "./station-releases.js";
import { getGamesPlayedReportRoute, getStationSessionGamesRoute, listPlayerGamesRoute, postStationGamePlaysRoute, } from "./game-plays.js";
import { clearStationAlertsRoute, getNeedsAttentionRoute, getStationHealthRoute, getStationTelemetryRoute } from "./station-health.js";
import { getFloorLiveRoute, getHqLiveRoute, getOrganizationReportOverviewRoute, getProductsReportRoute, getReportRangeRoute, getRevenueReportRoute, getSessionsReportRoute, getStaffReportRoute, getVenueReportOverviewRoute, } from "./reports.js";
import { getDailySummaryRoute, sendDailySummaryRoute } from "./daily-summary.js";
import { SETUP_ROUTES } from "./setup.js";
import { getIdCheckPhotoRoute, listIdChecksRoute, readSignedFileRoute, recordIdCheckRoute } from "./id-checks.js";
import { banPlayerAtVenueRoute, banPlayerOnPlatformRoute, banPlayerRoute, listPlayerBansRoute, unbanPlayerAtVenueRoute, unbanPlayerOnPlatformRoute, unbanPlayerRoute, } from "./player-bans.js";
import { getPlayerRoute, listPlayerOrdersRoute, listPlayerPassesRoute, listPlayerPointsRoute, listPlayerSessionsRoute, listPlayersRoute, listPlayerWalletRoute, updatePlayerRoute, } from "./players.js";
import { cancelStationPassPurchaseRoute, createPassProductRoute, getPassProductRoute, getStationPassPurchaseRoute, getStationPassShopRoute, purchaseStationPassRoute, grantPassRoute, listPassHoldingsRoute, listPassProductsRoute, refundPassHoldingRoute, sellPassRoute, updatePassProductRoute, voidPassHoldingRoute, } from "./passes.js";
import { getPublicVenueRoute, getPublicVenueShopRoute, listPublicVenuesRoute } from "./public-venues.js";
import { callStaffFromMyPlaySessionRoute, cancelMyStaffCallRoute, endMyPlaySessionRoute, getMyCurrentPlaySessionRoute, getMyOrderRoute, getMyVenuePassShopRoute, getMyWalletStatementRoute, listMyOrdersRoute, listMyPassesRoute, listMyPlaySessionsRoute, listMyWalletsRoute, lockMyPlaySessionRoute, pinPassOnMyPlaySessionRoute, purchaseMyPassRoute, beginMyOnlineTopUpRoute, getMyPaymentRoute, unlockMyPlaySessionRoute, } from "./me-player.js";
import { createRealtimeTokenRoute } from "./realtime.js";
import { getMyDemoRoute, startMyDemoRoute } from "./demo.js";
import { acceptConsentsRoute, completeMyProfileRoute, confirmContactChangeRoute, getMeRoute, getMyConsentsRoute, listMySessionsRoute, revokeMySessionRoute, updateMeRoute, } from "./me.js";
import { getNotificationPreferencesRoute, getNotificationPrefsRoute, listNotificationsRoute, markAllNotificationsReadRoute, markNotificationReadRoute, putNotificationPreferencesRoute, putNotificationPrefsRoute, } from "./notifications.js";
import { createScopeProbeRoute, getScopeProbeRoute, listScopeProbesRoute } from "./scope-probe.js";
import { getHqOrganizationSettingsRoute, getOrganizationSettingsRoute, getPlatformSettingsRoute, getVenueSettingsRoute, putHqOrganizationSettingsRoute, putOrganizationSettingsRoute, putPlatformSettingsRoute, putVenueSettingsRoute, } from "./settings.js";
import { getSharedDeviceRoute, listMyStaffPinsRoute, lockSharedDeviceRoute, openSharedDeviceRoute, resetStaffPinRoute, setMyStaffPinRoute, unlockSharedDeviceRoute, } from "./staff-pin.js";
import { createStationKioskTokenRoute, getStationContextRoute, getStationJwksRoute, getStationKioskSnapshotRoute, getStationLibraryRoute, getStationPolicyBundleRoute, readStationMessageRoute, } from "./station.js";
import { createStationClassRoute, listStationClassesRoute, updateStationClassRoute } from "./station-classes.js";
import { createStationRoute, listStationsRoute, removeStationRoute, unpairStationRoute, updateStationRoute } from "./stations.js";
import { createPublicDisplayRealtimeTokenRoute, createStationDisplayRoute, getPublicDisplayRoute, getStationDisplayRoute, revokeStationDisplayRoute, } from "./station-displays.js";
import { completeStationProfileRoute, getStationSignInOptionsRoute, requestStationEmailCodeRoute, requestStationPhoneCodeRoute, signInAtStationWithEmailRoute, signInAtStationWithPasswordRoute, signInAtStationWithPhoneRoute, verifyStationProfileEmailRoute, } from "./station-sign-in.js";
import { cancelStationSignInHandoffRoute, collectStationSignInHandoffRoute, confirmSignInHandoffRoute, createStationSignInHandoffRoute, endSignInHandoffSessionRoute, lookUpSignInHandoffRoute, } from "./station-sign-in-handoff.js";
import { cancelStationLinkHandoffRoute, collectStationLinkHandoffRoute, createStationLinkHandoffRoute, getStationConnectedAccountsRoute, lookUpStationLinkRoute, } from "./station-link-handoff.js";
import { archiveVenueRoute, createVenueRoute, getVenueRoute, listHqVenuesRoute, listVenuesRoute, updateVenueListingRoute, updateVenueRoute, } from "./venues.js";
import { adjustWalletRoute, getStationSessionWalletRoute, getWalletBalanceRoute, refundWalletRoute, topUpWalletRoute } from "./wallet.js";
import { beginOnlineWalletTopUpRoute, cancelPaymentIntentRoute, createSalePaymentIntentRoute, getOnlinePaymentsStatusRoute, getPaymentIntentRoute, paymentsCheckoutPageRoute, paymentsWebhookRoute, } from "./payments.js";
import { getHqOrganizationPaymentsRoute, refreshHqOrganizationPayeeRoute, saveHqOrganizationPayeeRoute } from "./hq-payments.js";
import { closeBusinessDayRoute, closeShiftRoute, getBusinessDayCloseRoute, getBusinessDayStatusRoute, getCurrentShiftRoute, getShiftCashTimelineRoute, getShiftRoute, joinShiftRoute, leaveShiftRoute, listShiftsRoute, openDrawerRoute, openShiftRoute, recordCashMovementRoute, signOffBusinessDayRoute, } from "./shifts.js";
import { createCounterRoute, listCountersRoute, updateCounterRoute } from "./counters.js";
import { INVENTORY_ROUTES } from "./inventory.js";
import { HQ_LEAD_ROUTES } from "./hq-leads.js";
import { HQ_ADDON_ROUTES } from "./hq-addons.js";
import { MIGRATION_ROUTES } from "./migrations.js";
import { MIGRATION_CLAIM_ROUTES } from "./migration-claims.js";
import { BUSINESS_DETAILS_ROUTES } from "./business-details.js";
import { createZoneRoute, listZonesRoute, updateZoneRoute } from "./zones.js";
import { disableTwoFactorRoute, enableTwoFactorRoute, generateTwoFactorBackupCodesRoute, verifyTwoFactorBackupCodeRoute, verifyTwoFactorTotpRoute, } from "./two-factor.js";
export * from "./access.js";
export * from "./audit.js";
export * from "./auth.js";
export * from "./brand.js";
export * from "./business-details.js";
export * from "./calls.js";
export * from "./commerce.js";
export * from "./discounts.js";
export * from "./device-auth.js";
export * from "./device-pairings.js";
export * from "./files.js";
export * from "./floor-plan.js";
export * from "./floor.js";
export * from "./franchisees.js";
export * from "./food.js";
export * from "./promotions.js";
export * from "./coupons.js";
export * from "./station-codes.js";
export * from "./station-account.js";
export * from "./station-sales.js";
export * from "./wallet-topup-requests.js";
export * from "./station-lockdown.js";
export * from "./offline-play.js";
export * from "./credit.js";
export * from "./tax-registration.js";
export * from "./tax-categories.js";
export * from "./rate-cards.js";
export * from "./kitchen.js";
export * from "./boot.js";
export * from "./boot-releases.js";
export * from "./inventory.js";
export * from "./migrations.js";
export * from "./migration-claims.js";
export * from "./printers.js";
export * from "./hello.js";
export * from "./internal.js";
export * from "./members.js";
export * from "./health.js";
export * from "./hq-addons.js";
export * from "./hq-catalogue.js";
export * from "./hq-leads.js";
export * from "./hq-organizations.js";
export * from "./hq-payments.js";
export * from "./hq-players.js";
export * from "./hq-providers.js";
export * from "./library.js";
export * from "./custom-apps.js";
export * from "./station-installs.js";
export * from "./station-wake.js";
export * from "./station-releases.js";
export * from "./game-plays.js";
export * from "./reports.js";
export * from "./daily-summary.js";
export * from "./setup.js";
export * from "./station-health.js";
export * from "./id-checks.js";
export * from "./player-bans.js";
export * from "./passes.js";
export * from "./guest-passes.js";
export * from "./payments.js";
export * from "./players.js";
export * from "./public-venues.js";
export * from "./realtime.js";
export * from "./me.js";
export * from "./me-player.js";
export * from "./demo.js";
export * from "./notifications.js";
export * from "./scope-probe.js";
export * from "./sessions.js";
export * from "./settings.js";
export * from "./shifts.js";
export * from "./counters.js";
export * from "./staff-pin.js";
export * from "./station.js";
export * from "./station-classes.js";
export * from "./stations.js";
export * from "./station-displays.js";
export * from "./station-sign-in.js";
export * from "./station-sign-in-handoff.js";
export * from "./station-link-handoff.js";
export * from "./venues.js";
export * from "./wallet.js";
export * from "./zones.js";
export * from "./two-factor.js";
// Annotated `readonly RouteConfig[]` rather than `as const satisfies`: the `as const` tuple of every
// route grew past the length TypeScript will serialise into this package's declaration file (TS7056).
// The annotation still checks each element is a `RouteConfig`; the order that matters is the runtime
// array's, which is unchanged.
export const V1_ROUTES = [
    helloRoute,
    listScopeProbesRoute,
    getScopeProbeRoute,
    createScopeProbeRoute,
    listOrganizationAuditRoute,
    exportOrganizationAuditRoute,
    listPlatformAuditRoute,
    exportPlatformAuditRoute,
    requestStationPhoneCodeRoute,
    signInAtStationWithPhoneRoute,
    signInAtStationWithPasswordRoute,
    // F-KIO-04: sign-up at the kiosk — the panel's options, the email path, and finishing the profile.
    getStationSignInOptionsRoute,
    requestStationEmailCodeRoute,
    signInAtStationWithEmailRoute,
    completeStationProfileRoute,
    verifyStationProfileEmailRoute,
    // ADR-0051, F-KIO-20: the station sign-in handoff.
    createStationSignInHandoffRoute,
    collectStationSignInHandoffRoute,
    cancelStationSignInHandoffRoute,
    lookUpSignInHandoffRoute,
    confirmSignInHandoffRoute,
    endSignInHandoffSessionRoute,
    // ADR-0053, F-KIO-21: linking Google, Discord or Steam from the kiosk during a session.
    getStationConnectedAccountsRoute,
    createStationLinkHandoffRoute,
    collectStationLinkHandoffRoute,
    cancelStationLinkHandoffRoute,
    lookUpStationLinkRoute,
    // F-ORG-01
    listVenuesRoute,
    createVenueRoute,
    getVenueRoute,
    updateVenueRoute,
    archiveVenueRoute,
    updateVenueListingRoute,
    // F-HQ-04: every venue on the Platform, with its listing flags (spec/14 §3.3).
    listHqVenuesRoute,
    // F-ORG-17: a franchisor's Brand HQ view of its own subtree — its direct franchisees and their
    // venues, bounded and audited (ADR-0019 Phase 2, spec/07 §7).
    listFranchiseesRoute,
    listFranchiseeVenuesRoute,
    listPublicVenuesRoute,
    getPublicVenueRoute,
    getPublicVenueShopRoute,
    createFileRoute,
    completeFileRoute,
    getFileRoute,
    // F-ORG-03
    listStationClassesRoute,
    createStationClassRoute,
    updateStationClassRoute,
    listZonesRoute,
    createZoneRoute,
    updateZoneRoute,
    getFloorPlanRoute,
    putFloorPlanRoute,
    // F-ORG-03 (rules 3, 4) / F-STN-02: the stations themselves — define and list (#408).
    listStationsRoute,
    createStationRoute,
    updateStationRoute,
    // ADR-0057: unpair a station's PC, and remove a station (soft: its history still names it).
    unpairStationRoute,
    removeStationRoute,
    // ADR-0033: a staff-run station's countdown screen — link, rotate, revoke; and the public read and realtime token.
    getStationDisplayRoute,
    createStationDisplayRoute,
    revokeStationDisplayRoute,
    getPublicDisplayRoute,
    createPublicDisplayRealtimeTokenRoute,
    // The live floor and the station drawer's live-ops (F-STN-14 … F-STN-20, spec/13 §3): the snapshot,
    // and the power, lock/unlock, maintenance and message commands issued through the gateway (spec/09 §5.1).
    getFloorRoute,
    stationPowerRoute,
    lockStationRoute,
    setStationMaintenanceRoute,
    messageStationRoute,
    // F-STN-26 (ADR-0055): skip a PC's start-up setup and open it for play now.
    skipStationSetupRoute,
    // F-SES-24 (spec/05 §8.4): mint an offline code for a station and action.
    generateOfflineCodeRoute,
    // Pairing a fresh PC to a venue and station (F-STN-02, spec/10 §3.2).
    createDevicePairingRoute,
    approveDevicePairingRoute,
    getDevicePairingRoute,
    // F-ORG-02: the settings registry at platform, organisation and venue scope.
    getPlatformSettingsRoute,
    putPlatformSettingsRoute,
    getHqOrganizationSettingsRoute,
    putHqOrganizationSettingsRoute,
    getOrganizationSettingsRoute,
    putOrganizationSettingsRoute,
    getVenueSettingsRoute,
    putVenueSettingsRoute,
    getMeRoute,
    updateMeRoute,
    completeMyProfileRoute,
    getMyConsentsRoute,
    acceptConsentsRoute,
    // The public demo's 15-minute window (F-DEM-01, spec/24 §3): the one thing the demo keeps on the server.
    getMyDemoRoute,
    startMyDemoRoute,
    getNotificationPrefsRoute,
    putNotificationPrefsRoute,
    // The in-app inbox and the preference model (F-NTF-03, F-NTF-01, spec/16 §2, §3).
    listNotificationsRoute,
    markNotificationReadRoute,
    markAllNotificationsReadRoute,
    getNotificationPreferencesRoute,
    putNotificationPreferencesRoute,
    // Members and invitations (F-IAM-08, spec/07 §6.5).
    listMembersRoute,
    changeMemberRoleRoute,
    changeMemberVenuesRoute,
    removeMemberRoute,
    createInvitationRoute,
    listInvitationsRoute,
    revokeInvitationRoute,
    acceptInvitationRoute,
    // Reading an invitation link before signing in (ADR-0046).
    previewInvitationRoute,
    // Bans (F-IAM-07, spec/07 §3.5).
    banPlayerAtVenueRoute,
    unbanPlayerAtVenueRoute,
    banPlayerRoute,
    unbanPlayerRoute,
    listPlayerBansRoute,
    banPlayerOnPlatformRoute,
    unbanPlayerOnPlatformRoute,
    // F-HQ-28: HQ's search of every player, and one player's platform record (spec/14 §10).
    listHqPlayersRoute,
    getHqPlayerRoute,
    listHqProvidersRoute,
    testHqProviderRoute,
    // Staff and roles management, limits (F-ORG-13, spec/07 §6.4, §6.5).
    getMemberRoute,
    changeMemberStatusRoute,
    getRoleRoute,
    changeRoleLimitsRoute,
    // A member's own comp limit, in place of their role's (spec/07 §6.4, owner decision 2026-09-30).
    getMemberLimitsRoute,
    changeMemberLimitsRoute,
    // ID checks (F-CMP-02, F-CMP-03, spec/07 §10).
    recordIdCheckRoute,
    listIdChecksRoute,
    getIdCheckPhotoRoute,
    readSignedFileRoute,
    // Custom roles and "what can I do" (F-IAM-11, spec/07 §6.2–§6.3).
    listRolesRoute,
    createRoleRoute,
    updateRoleRoute,
    deleteRoleRoute,
    getMyAccessRoute,
    // Where the signed-in person works, for choosing a venue (spec/13 §1, spec/15 §3.1).
    listMyOrganizationsRoute,
    listMyVenuesRoute,
    // The staff PIN at shared counter devices (F-IAM-10, spec/07 §6.7). `/members/shared-device`,
    // `/members/me/pin` and `/members/me/pins` are concrete paths beside `/members/{memberId}`; OpenAPI
    // matches a concrete path first, and the server mounts them before `getMemberRoute` so that it does too.
    listMyStaffPinsRoute,
    setMyStaffPinRoute,
    resetStaffPinRoute,
    openSharedDeviceRoute,
    getSharedDeviceRoute,
    unlockSharedDeviceRoute,
    lockSharedDeviceRoute,
    // Account security (F-IAM-12, spec/07 §3.3): changing an email address or a phone number, and
    // the person's own signed-in sessions.
    confirmContactChangeRoute,
    listMySessionsRoute,
    revokeMySessionRoute,
    // The brand configuration (F-ORG-04, spec/03 §12): what clients read, and HQ's runtime values.
    getMetaRoute,
    getHqBrandRoute,
    putHqBrandRoute,
    // The realtime gateway's token (INFRA-18, spec/09 §1).
    createRealtimeTokenRoute,
    // The device token exchange: a paired station proves itself and gets its tokens (F-STN-05, spec/07 §5).
    createDeviceAuthChallengeRoute,
    createDeviceAuthTokenRoute,
    // The station's own authenticated api surface: it reads back its identity with its device token
    // (F-STN-05, spec/07 §4.1, §5; spec/10 §3.3), reads its kiosk lock-screen identity, and mints a
    // kiosk token for the WebView2 UI's sign-in calls (spec/10 §3.3).
    getStationContextRoute,
    getStationKioskSnapshotRoute,
    createStationKioskTokenRoute,
    // F-STN-09 (spec/10 §6.2, spec/11 §6): the station pulls its current signed policy bundle, and the
    // public JWKS it verifies the bundle's Ed25519 signature against.
    getStationPolicyBundleRoute,
    getStationLibraryRoute,
    getStationJwksRoute,
    // F-STN-20 (spec/09 §6.2): the player acknowledged a staff message that needed it.
    readStationMessageRoute,
    // better-auth's, served at `/v1/auth/*` and documented here for the clients (`two-factor.ts`,
    // `auth.ts`). apps/server's auth contract suite checks each against better-auth's own.
    enableTwoFactorRoute,
    verifyTwoFactorTotpRoute,
    verifyTwoFactorBackupCodeRoute,
    generateTwoFactorBackupCodesRoute,
    disableTwoFactorRoute,
    ...AUTH_ROUTES,
    // An organisation's players, their notes and tags (F-ORG-05, F-ORG-06, spec/13 §8).
    listPlayersRoute,
    getPlayerRoute,
    updatePlayerRoute,
    listPlayerSessionsRoute,
    listPlayerOrdersRoute,
    listPlayerPassesRoute,
    listPlayerWalletRoute,
    listPlayerPointsRoute,
    // HQ onboards organisations: creates one and invites its owner, lists and reads them (F-HQ-02, spec/14 §3.1).
    // Self-serve onboarding, provider-gated (ADR-0019 §6, F-ORG-17 Phase 3): register one `pending`, then
    // approve or decline it.
    listHqOrganizationsRoute,
    createHqOrganizationRoute,
    registerPendingOrganizationRoute,
    getHqOrganizationRoute,
    decideHqOrganizationRoute,
    createHqOwnerInvitationRoute,
    // HQ follows the owner invitation: whether the owner joined, a fresh invitation, withdrawing one and its link
    // (ADR-0046, spec/14 §3.1).
    getHqOrganizationOwnerRoute,
    resendHqOwnerInvitationRoute,
    withdrawHqOwnerInvitationRoute,
    getHqOwnerInvitationLinkRoute,
    // HQ curates the global game catalogue: searches IGDB for base games, mirrors one, lists them
    // (F-CAT-01, F-CAT-07, spec/14 §6).
    searchCatalogueRoute,
    mirrorCatalogueGameRoute,
    refreshCatalogueGameRoute,
    // The per-game launch recipes HQ curates — how a station launches it (F-CAT-05, spec/10 §5.2).
    setCatalogueGameLaunchRecipesRoute,
    listCatalogueGamesRoute,
    // Trailers: manual HQ uploads for a catalogue game (F-CAT-01/-07, spec/14 §6).
    createGameTrailerRoute,
    listGameTrailersRoute,
    completeGameTrailerRoute,
    updateGameTrailerRoute,
    deleteGameTrailerRoute,
    // Game media: hero and logo art from SteamGridDB/IGDB, copied to our storage (F-CAT-01/-07, ADR-0028).
    listGameArtCandidatesRoute,
    setGameArtRoute,
    clearGameArtRoute,
    // Apps in the catalogue — non-game titles HQ adds by hand, with icons and a common-apps seed — and the
    // detection rules any title carries to stations (F-CAT-01, F-CAT-02, F-CAT-04; spec/14 §6, spec/10 §7.3).
    createCatalogueAppRoute,
    updateCatalogueAppRoute,
    seedCommonCatalogueAppsRoute,
    createAppIconUploadRoute,
    completeAppIconUploadRoute,
    setCatalogueTitleDetectionRoute,
    // Editing, hand-creating and archiving a catalogue game, its usage across venues, and HQ's detection testing tool
    // (F-CAT-01, F-CAT-07, F-HQ-16; spec/14 §6). `/games/manual` is concrete, so it is listed before any `/games/{id}`.
    createCatalogueGameRoute,
    updateCatalogueGameRoute,
    getCatalogueGameUsageRoute,
    archiveCatalogueGameRoute,
    unarchiveCatalogueGameRoute,
    testCatalogueDetectionRoute,
    // The session + money-ledger spine (F-SES-01, -04, -10, -14, -26; spec/05, spec/06 §2).
    startSessionRoute,
    // F-SES-21: the console's session drawer opens from a station tile — the station's live session.
    getStationSessionRoute,
    getSessionStatusRoute,
    getSessionTimelineRoute,
    // F-SES-21: the session's ledger, newest first, a page at a time.
    listSessionLedgerRoute,
    compSessionRoute,
    // F-SES-17 sell time, F-SES-20 message the player (spec/05 §7): the live actions on a running
    // session, beside comp and end.
    sellSessionTimeRoute,
    messageSessionRoute,
    // F-SES-18: move a running session to another station, with the cross-class warning (spec/05 §7).
    moveSessionRoute,
    endSessionRoute,
    // ADR-0033: staff lock and unlock a session on a staff-run station, which has no kiosk to lock from.
    lockSessionRoute,
    // ADR-0034: console sessions — the start preview, the change preview, add a block, change the controllers.
    quoteConsoleSessionRoute,
    quoteSessionChangeRoute,
    addSessionTimeRoute,
    setSessionControllersRoute,
    startStationSessionRoute,
    endStationSessionRoute,
    // F-KIO-13: the player buys more time at the PC — the station-authenticated twin of sell-time.
    addTimeStationSessionRoute,
    // F-KIO-13: "Keep playing with wallet" — the wallet starts funding this session, no order.
    useWalletStationSessionRoute,
    // F-WAL-04: "Use my wallet for play time" — the player's choice, and the running session re-planned on it at once.
    setStationWalletUseRoute,
    // F-SES-12 / F-SES-15: the station reports its session locked or unlocked (player step-away, idle
    // auto-lock, or the staff remote lock), so the session status and timeline follow it (spec/05 §6).
    lockStationSessionRoute,
    unlockStationSessionRoute,
    // F-SES-23: the station reports an end it made itself (offline lease expiry, reconnect reconcile), and
    // reads a fresh lease when the worker says the funded end moved; F-SES-09: pass or wallet first.
    reportStationSessionEndRoute,
    getStationSessionLeaseRoute,
    getStationFundingOptionsRoute,
    // Calls for help (F-SES-25, spec/05 §11, spec/13 §3.2): a player raises one from the station, the
    // front of house lists, answers and resolves them.
    raiseCallRoute,
    cancelCallRoute,
    listCallsRoute,
    acknowledgeCallRoute,
    resolveCallRoute,
    // The F&B menu and food orders (F-FNB-01/-02/-03, F-POS-01; spec/13 §6.1, spec/06 §8). The food
    // module owns the menu (organisation-scoped, with per-venue overrides) and the order foundation;
    // settlement is the commerce/payments build (ADR-0019).
    listMenuCategoriesRoute,
    createMenuCategoryRoute,
    updateMenuCategoryRoute,
    listMenuProductsRoute,
    createMenuProductRoute,
    getMenuProductRoute,
    updateMenuProductRoute,
    setProductAvailabilityRoute,
    getVenueMenuRoute,
    putVenueMenuOverridesRoute,
    // F-FNB-03: the venue's own "sold out" switch, gated by `products:availability`.
    setVenueProductAvailabilityRoute,
    placeFoodOrderRoute,
    listFoodOrdersRoute,
    getFoodOrderRoute,
    cancelFoodOrderRoute,
    // F-KIO-11 / F-POS-01: the player orders food and drink from the PC — the station-authenticated twin
    // of the counter's place-order, attributed to the station's own active session.
    placeStationFoodOrderRoute,
    // F-KIO-11: the station reads its venue's effective menu, device-authenticated, for the kiosk's Food screen.
    getStationMenuRoute,
    // The Sell point of sale (F-POS-09, F-POS-01, F-POS-12; spec/06 §8–§9, spec/13 §4). The `commerce`
    // module's unified mixed-basket sale, its cash and counter-UPI tenders with split tender, and the
    // ledger settlement the food module left as a seam (ADR-0020).
    createSaleRoute,
    // F-POS-03: the Sell cart prices itself with its promotions (and a code) before it is placed.
    quoteSaleRoute,
    listSalesRoute,
    getSaleRoute,
    takeSalePaymentRoute,
    cancelSaleRoute,
    // POS depth (F-POS-02, -05, -08, -13; spec/06 §8.4, §8.7, §10.2): discounts on a sale, refunds with
    // an approval path, and the sale's receipt document. Discount codes are organisation-scoped.
    applyDiscountCodeRoute,
    applyManualDiscountRoute,
    refundSaleRoute,
    approveSaleRefundRoute,
    getSaleDocumentRoute,
    sendSaleDocumentRoute,
    // B2B buyer and the printable document (F-CMP-07; spec/06 §10.1, §10.2).
    setSaleBuyerRoute,
    printSaleDocumentRoute,
    getCounterUpiRoute,
    listDiscountCodesRoute,
    createDiscountCodeRoute,
    updateDiscountCodeRoute,
    // Retail products with barcode scan at Sell (F-POS-11; spec/13 §4).
    lookupRetailProductRoute,
    // Automatic promotions applied to a sale by rule (F-POS-03; spec/06 §8.4).
    createPromotionRoute,
    listPromotionsRoute,
    updatePromotionRoute,
    // Coupons that grant a wallet bonus or points on redemption (F-POS-06; spec/06 §8.5).
    createCouponBatchRoute,
    listCouponBatchesRoute,
    redeemCouponRoute,
    // Codes at the kiosk (F-POS-02, F-POS-06): check a discount code, redeem a coupon, device-authenticated.
    checkStationDiscountCodeRoute,
    quoteStationSaleRoute,
    redeemStationCouponRoute,
    // Lockdown hardening (F-LCK-06, F-LCK-09, F-STN-21; spec/11 §4.3, §7, §9): the recovery code for station-cli undo,
    // the lockdown test and its station report, and maintenance access at the PC (staff sign-in, entry/exit audit).
    issueStationRecoveryCodeRoute,
    runStationLockdownTestRoute,
    getStationLockdownTestRoute,
    reportStationLockdownTestRoute,
    signInStationMaintenanceRoute,
    reportStationMaintenanceEventRoute,
    // Offline play per venue (F-SES-23, F-SES-24; spec/05 §8): the station's offline policy and staff-code
    // verifiers, its report of a session it ran offline, and the console's staff codes and offline sessions.
    getStationOfflinePolicyRoute,
    reportStationOfflineSessionRoute,
    issueOfflineStaffCodesRoute,
    listOfflineStaffCodesRoute,
    revokeOfflineStaffCodeRoute,
    listOfflineSessionsRoute,
    resolveOfflineSessionRoute,
    // On account — money owed: the balance and limit, and the receivable's write-off and settlement,
    // plus the on-account checkout tender (F-POS-07; spec/06 §8.6).
    getPlayerCreditRoute,
    setPlayerCreditRoute,
    writeOffReceivableRoute,
    settleReceivableRoute,
    takeSaleOnAccountRoute,
    // A venue's tax registration — its tax mode and GSTIN — as a dated, audited change (F-PAY-11;
    // spec/06 §10.4). The dated settings `tax.mode` and `tax.gstin` are read from and written only
    // through here, never through `PUT …/settings`.
    getVenueTaxRegistrationRoute,
    scheduleVenueTaxRegistrationRoute,
    withdrawVenueTaxRegistrationRoute,
    // A venue's rate card: pay-as-you-go per station class, versioned, with bands, minimum and cap (F-PRC-10 … F-PRC-12;
    // spec/06 §4). A class the card leaves out keeps the venue's flat rate.
    getVenueRateCardRoute,
    publishVenueRateCardRoute,
    // The organisation's tax categories (F-PAY-11; spec/06 §10.1).
    listTaxCategoriesRoute,
    createTaxCategoryRoute,
    updateTaxCategoryRoute,
    // The kitchen display and ticket states (F-FNB-04; spec/13 §6.2), and a ticket's printing and
    // routing (F-FNB-05; spec/13 §6.3, §11). Built from the food module's events through the outbox;
    // the live push (`kitchen.ticket.*` on `venue:{v}:kitchen`) rides in with the display.
    listKitchenTicketsRoute,
    advanceKitchenTicketRoute,
    printKitchenTicketRoute,
    // Printers, print jobs and the receipt (F-OPS-08, F-FNB-05, F-STN-13; spec/13 §11, spec/10 §10): the venue's
    // printer registry with its purpose routing and fallback, a test print, the recent jobs, a sale's receipt, and the
    // cloud printers' polling (Star CloudPRNT, Epson Server Direct Print — unauthenticated by session, the URL's key
    // is the credential).
    listPrintersRoute,
    createPrinterRoute,
    updatePrinterRoute,
    archivePrinterRoute,
    testPrinterRoute,
    listPrintJobsRoute,
    printSaleReceiptRoute,
    starCloudPrntPollRoute,
    starCloudPrntJobRoute,
    starCloudPrntConfirmRoute,
    epsonServerDirectPrintRoute,
    // The wallet: stored value that funds sessions and purchases (F-WAL-01, -02, -04, -06, -07, -08;
    // spec/06 §5). The statement fills the player's wallet tab (`listPlayerWalletRoute`, above); the
    // adjustment and the refund are the staff money-back doors on it.
    topUpWalletRoute,
    getWalletBalanceRoute,
    adjustWalletRoute,
    refundWalletRoute,
    // The station reads its session player's balance for the kiosk session bar (F-KIO-07), device-authenticated.
    getStationSessionWalletRoute,
    // Wallet top-ups asked for at the kiosk (F-KIO-10): UPI through the provider, or a request the desk completes.
    requestStationWalletTopUpRoute,
    getStationWalletTopUpRoute,
    cancelStationWalletTopUpRoute,
    listWalletTopUpRequestsRoute,
    completeWalletTopUpRequestRoute,
    cancelWalletTopUpRequestRoute,
    // The kiosk Account area (F-KIO-15): the session player's profile, passes, wallet, orders and settings; pin a pass.
    getStationAccountRoute,
    pinStationSessionPassRoute,
    // A kiosk sale's outstanding amount for a split tender, and a fresh UPI request for it (F-KIO-14).
    getStationSaleOutstandingRoute,
    retryStationSaleUpiRoute,
    // Online payments on the payment provider (F-PAY-03, F-WAL-02; spec/06 §9.3, spec/08 §4.8, §4.18):
    // an intent for a sale or a wallet top-up, polled until the provider's webhook (or the reconciliation
    // job) reports it captured, and the webhook itself — unauthenticated, verified by signature.
    createSalePaymentIntentRoute,
    getPaymentIntentRoute,
    cancelPaymentIntentRoute,
    getOnlinePaymentsStatusRoute,
    beginOnlineWalletTopUpRoute,
    paymentsWebhookRoute,
    // The page a provider's hosted checkout opens from (ADR-0061): unauthenticated, the session in the fragment.
    paymentsCheckoutPageRoute,
    // HQ's payments oversight for one organisation (F-PAY-05, F-HQ-13; ADR-0061): its payee and commission.
    getHqOrganizationPaymentsRoute,
    saveHqOrganizationPayeeRoute,
    refreshHqOrganizationPayeeRoute,
    // Shifts, cash and the day close (F-OPS-01 … F-OPS-07; spec/13 §10, spec/06 §2.4). A staff
    // member's till session, its cash movements, its blind close with the variance, and the
    // business-day close that reconciles the day's takings across tenders through the ledger. The
    // concrete `/shifts/current` is listed before `/shifts/{shiftId}` so the document and the server
    // match it first.
    openShiftRoute,
    listShiftsRoute,
    getCurrentShiftRoute,
    getShiftRoute,
    // F-OPS-04: every drawer event of a shift in order, with the running expected drawer.
    getShiftCashTimelineRoute,
    recordCashMovementRoute,
    closeShiftRoute,
    // ADR-0029: joining and leaving a shared drawer.
    joinShiftRoute,
    leaveShiftRoute,
    getBusinessDayCloseRoute,
    closeBusinessDayRoute,
    // ADR-0029: the business day as the counter sees it (rollover, mode, drawer custody), and a manager's sign-off of a
    // day that closed by itself at the cutoff.
    getBusinessDayStatusRoute,
    signOffBusinessDayRoute,
    // Open drawer (F-OPS-09): a no-sale kick through the receipt printer, permissioned and audited.
    openDrawerRoute,
    // ADR-0032: the venue's counters a shift starts at, each with its running drawer (the running counters panel).
    listCountersRoute,
    createCounterRoute,
    updateCounterRoute,
    // Passes: versioned pass products, holdings, and the sell/grant/refund/void actions (F-PRC-01 …
    // F-PRC-07; spec/06 §3). Value moves through the ledger; every sell, grant, refund and void is
    // audited. Selling rides `orders:create`; the rest have `passes:*` codes.
    listPassProductsRoute,
    createPassProductRoute,
    getPassProductRoute,
    updatePassProductRoute,
    sellPassRoute,
    grantPassRoute,
    listPassHoldingsRoute,
    refundPassHoldingRoute,
    voidPassHoldingRoute,
    // The station reads its venue's buyable pass shop for the kiosk Time screen (F-KIO-10), device-authenticated.
    getStationPassShopRoute,
    // Buying a pass from the kiosk (F-KIO-14): wallet, pay at the desk, UPI QR or on account, device-authenticated.
    purchaseStationPassRoute,
    getStationPassPurchaseRoute,
    cancelStationPassPurchaseRoute,
    // Guest passes (F-SES-06, F-SES-07, ADR-0059): the venue's guest passes for the counter, "I have a ticket" at the
    // kiosk (kiosk token), and a player claiming a ticket into their account.
    listGuestPassesRoute,
    redeemStationTicketRoute,
    claimGuestPassRoute,
    // The venue library: the titles a venue offers, drawn from the platform catalogue (F-CAT-02;
    // spec/13 §9.1). Browse the catalogue to add, add a game, place it on classes and in a kiosk
    // category, edit and remove.
    browseVenueCatalogueRoute,
    listLibraryEntriesRoute,
    addLibraryEntryRoute,
    updateLibraryEntryRoute,
    removeLibraryEntryRoute,
    // An organisation's custom apps (spec/13 §9): its own titles not in the catalogue, offered by any of its venues.
    listCustomAppsRoute,
    createCustomAppRoute,
    updateCustomAppRoute,
    archiveCustomAppRoute,
    createCustomAppIconUploadRoute,
    completeCustomAppIconUploadRoute,
    browseVenueCustomAppsRoute,
    // Install detection (F-CAT-03; spec/10 §7.2): the station reports what is installed on it, pulls which other
    // stations of its venue have each title, and the console's station sheet reads a station's install state.
    putStationInstalledRoute,
    getStationLibraryAvailabilityRoute,
    getStationInstalledTitlesRoute,
    // The console's library area: the titles × stations matrix, what the PCs have that the library does not, and
    // an on-demand rescan (`station.library.rescan`).
    getLibraryInstallMatrixRoute,
    listDetectedTitlesRoute,
    rescanLibraryInstallsRoute,
    // Install one app on demand (F-CAT-09, ADR-0056): on one PC from its station window, or on every PC missing it from the
    // library card (`station.app.install`), as soon as each PC is free.
    installStationAppRoute,
    installLibraryEntryRoute,
    // A detected title with no catalogue match becomes a request to HQ (F-CAT-03, F-CAT-08): the venue asks, HQ's inbox
    // lists and answers.
    createCatalogueRequestRoute,
    listCatalogueRequestsRoute,
    resolveCatalogueRequestRoute,
    // Wake-on-LAN readiness (F-STN-17; spec/10 §6.5): the station reports Fast Startup and its armed wired adapters,
    // and the console's station drawer reads it.
    putStationWakeReadinessRoute,
    getStationWakeStatusRoute,
    // Waking without the cloud (F-STN-17, 2026-10-01): every device keeps the venue's wake list and reports what it
    // woke on its own (Clavian Counter, the scheduled opening-hours wake, the kiosk staff menu) when next online.
    getStationWakeListRoute,
    postStationWakeSendRoute,
    // Game plays (F-CAT-04; spec/04 §4 `game_play`): the station reports the titles played in its sessions; the kiosk
    // reads the playing player's top titles, the player drawer's Games tab and the venue's Games played report.
    postStationGamePlaysRoute,
    getStationSessionGamesRoute,
    listPlayerGamesRoute,
    getGamesPlayedReportRoute,
    // The canonical metrics (F-ANL-01, F-ANL-02; spec/17 §3): the venue's and the organisation's Reports overview, the
    // floor's live figures (takings today by M-01) and HQ Live.
    getVenueReportOverviewRoute,
    getOrganizationReportOverviewRoute,
    // The Reports screen's tabs (F-ANL-03): a preset's business days, revenue, sessions and occupancy, products, staff.
    getReportRangeRoute,
    getRevenueReportRoute,
    getSessionsReportRoute,
    getProductsReportRoute,
    getStaffReportRoute,
    // The owners' daily summary (F-ANL-07, ADR-0044; N-27): one business day's KPIs, and emailing it to yourself now.
    getDailySummaryRoute,
    sendDailySummaryRoute,
    getFloorLiveRoute,
    getHqLiveRoute,
    // Station health (F-STN-11, F-LCK-02, F-LCK-08, F-STN-15): the drawer's health section, the telemetry behind it and
    // the floor's "Needs attention" (open alerts, failed and expired commands).
    getStationHealthRoute,
    getStationTelemetryRoute,
    getNeedsAttentionRoute,
    clearStationAlertsRoute,
    // Station auto-update (F-STN-12; spec/10 §8, spec/14 §12): HQ registers signed releases and stages them per
    // channel; each station asks what to run, reports what it runs, and reads the release keys; the console reads
    // each PC's version and updater state.
    registerStationReleaseRoute,
    listStationReleasesRoute,
    updateStationReleaseRoute,
    listStationRolloutsRoute,
    setStationRolloutRoute,
    getStationFleetRoute,
    listVenueStationClientsRoute,
    getVenueStationInstallersRoute,
    // Update now (2026-10-07, spec/10 §8.2): staff ask one station to check for its release and install it once free.
    installStationClientUpdateNowRoute,
    getStationClientUpdateRoute,
    putStationClientUpdateStatusRoute,
    getStationReleaseKeysRoute,
    // Stock (F-FNB-07 … F-FNB-13, F-POS-11's inventory tie-in; spec/13 §6.4, ADR-0040): a venue's stock items, the movement
    // ledger, deliveries, counts, waste, recipes, suppliers, copying from another venue and the stock reports.
    ...INVENTORY_ROUTES,
    // The organisation's business details — legal name, PAN, registered address — as its owner completes them (ADR-0046).
    ...BUSINESS_DETAILS_ROUTES,
    // Guided venue setup (F-HQ-03, ADR-0047; spec/14 §3.2, spec/13 §13.1): an organisation's and a venue's setup steps,
    // computed from their state; skipping a suggested step; and HQ's view across organisations.
    ...SETUP_ROUTES,
    // Moving a café to Clavian from another platform (F-HQ-40, ADR-0048; spec/14 §3.5, spec/13 §8.2): HQ's migration runs —
    // upload, mapping, validation, the dry run, ticks, the batched import, undo and the report — and the venue's read-only
    // list of players moved from the previous system.
    ...HQ_LEAD_ROUTES,
    // Provider-priced add-ons (F-BOOT-17; spec/14 §4.5, spec/25 §17): the catalogue, one organisation's add-ons as HQ
    // attaches and changes them, and the organisation's own read of what it pays.
    ...HQ_ADDON_ROUTES,
    ...MIGRATION_ROUTES,
    ...MIGRATION_CLAIM_ROUTES,
    // The player's own play, money and orders (ADR-0054). Last, so the shared ids they meet nullable (a call's player
    // and session) are first met clean by the routes above.
    listMyWalletsRoute,
    getMyWalletStatementRoute,
    listMyPassesRoute,
    listMyPlaySessionsRoute,
    getMyCurrentPlaySessionRoute,
    lockMyPlaySessionRoute,
    unlockMyPlaySessionRoute,
    endMyPlaySessionRoute,
    pinPassOnMyPlaySessionRoute,
    callStaffFromMyPlaySessionRoute,
    cancelMyStaffCallRoute,
    listMyOrdersRoute,
    getMyOrderRoute,
    getMyVenuePassShopRoute,
    purchaseMyPassRoute,
    // Online payment from the web (ADR-0061): top the wallet up online at a café, and read one's own payment.
    beginMyOnlineTopUpRoute,
    getMyPaymentRoute,
    // Clavian Boot (ADR-0063, spec/25 §14; F-BOOT-01, -05, -06, -11, -12, -13, -14, -16, -19, -20): the venue's boot
    // server, images, PCs, edits, wipes, rollouts and health, and the boot server's own pairing and signed config.
    ...BOOT_ROUTES,
    // Boot server releases (F-BOOT-23, spec/25 §13.6): HQ registers the signed releases and makes one current per channel;
    // a boot server reads the current one, and installs it only when staff say so.
    ...BOOT_RELEASE_ROUTES,
];
/**
 * The endpoints that are not on `/v1`: liveness and readiness (spec/08 §4.20). They are part of the
 * contract — one schema, one document — but deliberately outside `V1_ROUTES`, because that list is
 * what the versioning rules, the generated clients and the breaking-diff check in CI apply to.
 * Nothing generates a client method for a load-balancer probe.
 */
export const OPERATIONAL_ROUTES = [healthzRoute, readyzRoute];
/**
 * Service-to-service endpoints under `/internal/v1` (spec/08 §5): the realtime gateway and the api
 * calling each other (`internal.ts`). In the contract and the document like everything else, and —
 * like the probes — outside `V1_ROUTES`, so no client is generated for them and the `/v1`
 * breaking-change gate does not apply.
 */
export { INTERNAL_ROUTES };
/**
 * Every route the server mounts, in the order the document lists them. Annotated `readonly
 * RouteConfig[]` rather than an inferred `as const` tuple: the spread of the three lists is only ever
 * iterated (the OpenAPI document is built from it), and the combined literal tuple is large enough
 * that TypeScript refuses to serialise its inferred type (TS7056).
 */
export const ALL_ROUTES = [...V1_ROUTES, ...OPERATIONAL_ROUTES, ...INTERNAL_ROUTES];
//# sourceMappingURL=index.js.map